// queries/getTransactionDetails.ts

import { gql } from '@apollo/client';

export const GET_TRANSACTION_DETAILS = gql`
  query GetOrdersByTransactionId($transactionId: String!) {
    getOrdersByTransactionId(transactionId: $transactionId) {
      transaction_id
      transaction_date
      orders {
        order_id
        orderNumber
        totalAmount
        commission
        netEarnings
        orderDate
      }
    }
  }
`;
        